<template>   
   <HeaderDash />
   
   <ContentUpgrade /> 
</template>

<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/team/dashboard/HeaderDash.vue'

import ContentUpgrade from '@/components/team/dashboard/modules/upgrade/ContentUpgrade.vue'
export default 
{
  name: 'Upgrade',
  components: 
  {
    HeaderDash,
 
    ContentUpgrade
  }
}
</script>

<style>


</style>
